import * as Yup from 'yup';
import { notAllowedWord, reservedValues } from '../formElements/reservedKeywords';

export const customConstraintSchema = {
  name: '',
  constraintType: '',
  fields: [],
};
export const customConstraintSchemaValidation = Yup.object().shape({
  name: Yup.string()
    .required('Name is Required.')
    .matches(/^[0-9A-Za-z\s]+$/, 'Name should not contain special characters or numbers.')
    .max(100, 'Name can not be more than 100 characters.')
    .test('reserved', 'This is reserved word please use another', (value) => {
      const lowercaseValue = value ? value.toLowerCase() : '';
      return !reservedValues.includes(lowercaseValue);
    })
    .test('not-allowed', 'This type of word not allowed.', (value) => {
      const lowercaseValue = value ? value.toLowerCase() : '';
      return !notAllowedWord.includes(lowercaseValue);
    }),
  fields: Yup.array().required("Fields can't be blank"),
});
